<template>
  <chapter-form
    v-model="form"
    :max="course.ordered_chapter_ids.length + 1"
    class="max-w-3xl bg-white"
    @submit="submit"
  >
    <div class="flex items-center justify-end border-t px-8 py-4">
      <loading-button :loading="form.processing" class="btn-teal" type="submit">
        Create Chapter
      </loading-button>
    </div>
  </chapter-form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import ChapterForm from './Form.vue';
import axios from 'axios';

export default {
  components: {
    LoadingButton,
    ChapterForm,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  emits: ['success'],
  data() {
    return {
      form: this.$inertia.form({
        chapter: {},
        position: this.course.ordered_chapter_ids.length + 1,
      }),
    };
  },
  methods: {
    async submit() {
      try {
        await axios.post(this.$routes.course_chapters(this.course.id), {
          format: 'json',
          ...this.form,
        });
        this.form.reset('chapter');
        this.$emit('success');
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
